const {
  isPlainObject
} = require('lodash');
const {
  getContentValue,
  getFlattenedContentValues,
  appendPath
} = require('@truqc/content-path');
const {
  combForSource,
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate ifOptionBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const comb = await combForSource(source, content, parentContentPath, transientContext, nativeFunctions);
  const getOption = item => {
    if (!isPlainObject(item)) {
      return undefined;
    }
    const keys = Object.keys(item);
    if (keys.count === 0) {
      return undefined;
    }
    return keys[0];
  };
  const combOption = item => comb(getOption(item));
  const boundEvaluateSource = subsource => evaluateSource(subsource, content, parentContentPath, transientContext, nativeFunctions);
  const atPath = await boundEvaluateSource(source.atPath);
  if (atPath !== undefined) {
    const fullPath = appendPath(parentContentPath, atPath);
    const value = getContentValue(fullPath, content);
    return combOption(value);
  }
  const getEvaluatedValues = async (paths, requireAllValues) => {
    const evaluatedPaths = (await boundEvaluateSource(paths)) || [];
    const fullPaths = evaluatedPaths.map(path => appendPath(parentContentPath, path));
    return getFlattenedContentValues(fullPaths, content, requireAllValues);
  };
  const atAnyPaths = await boundEvaluateSource(source.atAnyPaths);
  if (atAnyPaths !== undefined) {
    const values = (await getEvaluatedValues(atAnyPaths, false)) || [];
    return values.length > 0 && values.some(combOption);
  }
  const atAllPaths = await boundEvaluateSource(source.atAllPaths);
  if (atAllPaths !== undefined) {
    const values = (await getEvaluatedValues(atAllPaths, true)) || [];
    const doesNotEqual = await evaluateSource(source.doesNotEqual, content, parentContentPath, transientContext, nativeFunctions);
    if (doesNotEqual !== undefined && values.length === 0) {
      // see test case 'should return true when option
      // atAllPaths doesNotEqual has nonexistent paths'
      return true;
    }
    return values.length > 0 && values.every(combOption);
  }
  return false;
};
module.exports = {
  evaluate
};